export const sortByIndex = (data, desc = false) => {
  const sortedItems = data.sort((a, b) => {
    return desc ? b.index - a.index : a.index - b.index
  })
  return sortedItems
}
